import React from 'react'
import Navigation from './Navigation'
import { Route, withRouter } from 'react-router-dom'
import { addLocaleData, IntlProvider } from 'react-intl'

import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'

import messages from '../../messages'
import { BgDD } from './styles'
import { checkJapanese, flattenMessages } from '../../lib'
import { checkIftokenExists } from '../authenticateHOC'

// Language dependencies
addLocaleData([...en, ...ja])

const Layout = ({component: Component, ...rest}) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <IntlProvider
          locale={checkJapanese() ? 'ja' : 'en'}
          messages={flattenMessages(
            messages[checkJapanese() ? 'ja' : 'en']
          )}>
          <BgDD className="min-h-inherit w-100">
            {rest.isCheckingToken ? (
              <div className="min-h-inherit w-100 flex justify-center items-center">
                Loading...
              </div>
            ) : (
              <div className="min-h-inherit w-100 pt3 pr5 pl5">
                <Navigation {...rest} />
                <div>
                  <Component {...matchProps} />
                </div>
              </div>
            )}
          </BgDD>
        </IntlProvider>
      )}
    />
  )
}

export default withRouter(checkIftokenExists(Layout))



// WEBPACK FOOTER //
// ./src/layouts/LoggedOut/Layout.js